import {Member} from "../member/member";

export class Category {
  id: number;
  name: string;
  checked?: boolean;
}

export class BenefitBoard{
  id?: number;
  categoryName?: string;

  category: any;
  name:  string;
  benefits: string;
  applyLink: string;
  applyMethod: string;
  applyHelp: string;
  link: string;
  logoImg: string;
  promoImg: string;
  introduce: string;
  url: string;
}


// WEBPACK FOOTER //
// ./src/app/service/benefit/benefit.ts